import { Component } from "@angular/core";

@Component({
    selector: "app-custom-blocks-cta",
    templateUrl: "./custom-blocks-cta.component.html",
    styleUrl: "./custom-blocks-cta.component.scss",
    standalone: false,
})
export class CustomBlocksCtaComponent {}
